export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'SoloLearn Certification',
            details : 'SoloLearn certifications validate your expertise and showcase your ability to transform your online presence.',
            date : 'Apr, 2020',
            field : 'Web Developement',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwSDod3Q6uZJJbFnv4SrYWa95zISHjsAaeBw&usqp=CAU'
        },
        {
            id : 2,
            title : 'Masai School Certification',
            details : 'Validate Web Development skills and front-end as well as back-end expertise to grow your career and business.',
            date : 'Aug 20, 2019',
            field : 'Automation',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIr_d5fGKepx04SFdlqEgjPiWPwFfZtp4-vw&usqp=CAU'
        },
        {
            id : 3,
            title : 'Professional Data Engineer Certification',
            details : 'Professional Data Engineers enable data-driven decision making by collecting, transforming, and publishing data.',
            date : 'Aug 20, 2019',
            field : 'Automation',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/